<template>
    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >
        <rkm-tab
            active
            title="Identificação"
        >
            <TabIdentificacao
                ref="TabIdentificacao"
                :form="form"
                :model="model"
            />
        </rkm-tab>

        <rkm-tab title="Endereço">
            <TabEndereco
                ref="TabEndereco"
                :form="form"
                :model="model"
            />
        </rkm-tab>

        <rkm-tab title="Documentos">
            <TabDocumentos
                ref="TabDocumentos"
                :form="form"
                :model="model"
            />
        </rkm-tab>

        <rkm-tab title="Lotações">
            <TabLotacoes
                ref="TabLotacoes"
                :form="form.lotacao"
                :model="model"
            />
        </rkm-tab>

        <rkm-tab title="Login">
            <TabLogin
                ref="TabLogin"
                :model="model"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import TabIdentificacao from './tabs/Identificacao'
import TabEndereco from './tabs/Endereco'
import TabDocumentos from './tabs/Documentos'
import TabLotacoes from './tabs/Lotacoes'
import TabLogin from './tabs/Login'

export default {
    components: {
        TabIdentificacao,
        TabEndereco,
        TabDocumentos,
        TabLotacoes,
        TabLogin,
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabIdentificacao,
            this.$refs.TabEndereco,
            this.$refs.TabDocumentos,
            this.$refs.TabLotacoes,
            this.$refs.TabLogin,
        ]
    }
}
</script>